<template>
	 <div class="">
						<div id="tab1" class="container container--narrow mgt-200" >
								<div class=" t-center mgt-100">
										<img src="/images/no-degree-data-image.svg" alt="" class="no-degree-image mgx-auto">
								</div>
								<div class="mgt-24 t-center t-headline8 font-r">
										{{$t('3108')}}
								</div>
								<div class="mgt-4 t-center t-body1 t-color-bodyGrayA">{{$t('3109')}}</div>
						</div>
						
		</div> 
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
	
};
</script>
